import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
// import Test from './test';
import Guide from './guide';
import Banner from './banner';
import VideoMask from './videoMask';
import Nav from './nav';
import Guest from './guest';
import Support from './support';
import Review from './review';
import Qrcode from './qrcode';
import ChipView from './chipView';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Layout = ({ content }) => {
    const [maskVisible, setMaskVisible] = useState(false);
    const [currentVideo, setCurrentVideo] = useState({});
    const [navIndex, setNavIndex] = useState(0);
    let guestMaskData = [
        {
            guestVideoList: content.guest1VideoList,
            guestSayAndImageList: content.guest1SayAndImageList,
        },
        {
            guestVideoList: content.guest2VideoList,
            guestSayAndImageList: content.guest2SayAndImageList,
        },
        {
            guestVideoList: content.guest3VideoList,
            guestSayAndImageList: content.guest3SayAndImageList,
        },
        {
            guestVideoList: content.guest4VideoList,
            guestSayAndImageList: content.guest4SayAndImageList,
        },
        {
            guestVideoList: content.guest5VideoList,
            guestSayAndImageList: content.guest5SayAndImageList,
        },
        {
            guestVideoList: content.guest6VideoList,
            guestSayAndImageList: content.guest6SayAndImageList,
        },
        {
            guestVideoList: content.guest7VideoList,
            guestSayAndImageList: content.guest7SayAndImageList,
        },
        {
            guestVideoList: content.guest8VideoList,
            guestSayAndImageList: content.guest8SayAndImageList,
        },
        {
            guestVideoList: content.guest9VideoList,
            guestSayAndImageList: content.guest9SayAndImageList,
        },
        {
            guestVideoList: content.guest10VideoList,
            guestSayAndImageList: content.guest10SayAndImageList,
        },
        {
            guestVideoList: content.guest11VideoList,
            guestSayAndImageList: content.guest11SayAndImageList,
        },
        {
            guestVideoList: content.guest12VideoList,
            guestSayAndImageList: content.guest12SayAndImageList,
        },
    ];

    guestMaskData = guestMaskData.filter((item) => item.guestVideoList.length > 0);

    guestMaskData = guestMaskData.reverse();

    return (
        <div className={styles.layout}>
            {/* <Chip id="260756" type="struct" title="胶片人物图片" content={content?.guideImages}>
                <Guide />
            </Chip> */}

            <Banner onChangeMaskVisible={setMaskVisible} brandWinePic={content.brandWinePic} content={content?.noticeVideo} onChangeCurrentVideo={setCurrentVideo} />
            {/* <Test /> */}
            <Nav content={content?.guestData} navIndex={navIndex} />
            <Guest
                content={content?.guestData}
                guestMaskData={guestMaskData}
                brandWinePic={content.brandWinePic}
                setNavIndex={setNavIndex}
                onChangeCurrentVideo={setCurrentVideo}
                onChangeMaskVisible={setMaskVisible}
            />
            <div className={styles.pageBottom}>
                <Chip id="260760" type="struct" title="广告权益" content={content?.supportData}>
                    <Support />
                </Chip>
                <Chip id="260759" type="struct" title="往期回顾" content={content?.reviewData}>
                    <Review setNavIndex={setNavIndex} guestData={content?.guestData} />
                </Chip>
                <Chip id="260758" type="struct" title="二维码" content={content?.qrcodeData}>
                    <Qrcode />
                </Chip>
            </div>
            <VideoMask visible={maskVisible} onChangeVisible={setMaskVisible} videoInfo={currentVideo} />
            <ChipView />
            <ChipEdit transform={chipDataTransform} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
